module.exports = __webpack_public_path__ + "img/pp2.57d8d560.png";